export const featuredPortfolio = [
  {
    id: 1,
    title: "Petroleum Movement Monitoring",
    subtitle: "Ministry of Energy — Saudi Arabia",
    clientBadge: "Ministry of Energy",
    category: "enterprise",
    categories: ["enterprise", "angular", "gis"],
    role: "Frontend Engineer",
    domain: "moenergy.gov.sa (Internal Network)",
    desc: "Real-time supply chain monitoring platform integrating Aramco and Transport Authority telemetry data to combat fuel misuse and optimize nationwide distribution transparency.",
    highlights: [
      "Integrated real-time Aramco & Transport Authority telemetry feeds",
      "Architected modular Angular ABP dashboard with 30% faster load times",
      "Interactive Esri GIS spatial tracking for national fuel routes",
    ],
    img: "assets/ministry_of_energy.png",
    isLogo: true,
    logoBg: "light",
    demo: "",
    isInternal: true,
    tags: [
      "Angular",
      "ABP Framework",
      "Esri JS SDK",
      "TypeScript",
      "Highcharts",
      "REST APIs",
    ],
  },
  {
    id: 2,
    title: "COP16 Event Management System",
    subtitle: "UN Convention to Combat Desertification",
    clientBadge: "United Nations COP16",
    category: "angular",
    categories: ["enterprise", "angular"],
    role: "Senior Frontend Developer",
    domain: "unccdcop16.org",
    desc: "Global conference management platform for UN COP16 handling high-traffic delegate registration, internationalized dynamic scheduling, and live content broadcasting.",
    highlights: [
      "Handled 100,000+ international delegate registrations & accreditation",
      "Engineered real-time speaker scheduling & multilingual event broadcasts",
      "Achieved 95+ Core Web Vitals score through Angular architecture & performance tuning",
    ],
    img: "assets/cop16_platform.png",
    demo: "https://www.unccdcop16.org",
    isInternal: false,
    tags: [
      "Angular",
      "TypeScript",
      "Tailwind CSS",
      "REST APIs",
      "Performance Tuning",
    ],
  },
  {
    id: 6,
    title: "Rosewood Corporate Experience",
    subtitle: "Luxury Architecture & Design Showcase",
    clientBadge: "Enterprise Brand Showcase",
    category: "react",
    categories: ["enterprise", "react", "nextjs"],
    role: "Fullstack Developer",
    domain: "rosewoodeg.com",
    desc: "High-performance luxury furniture and interior design brand showcase with fluid animations, dynamic product catalog, and responsive layouts.",
    highlights: [
      "Fluid micro-animations & smooth visual storytelling with Next.js & React",
      "Dynamic luxury catalog filtering with instantaneous client-side search",
      "100% responsive architectural layout tailored for high-end luxury buyers",
    ],
    img: "assets/rosewood_web.png",
    demo: "https://rosewoodeg.com",
    isInternal: false,
    tags: ["Next.js", "React", "Tailwind CSS", "UI/UX Design", "Responsive"],
  },
  {
    id: 3,
    title: "Tashejeer Greening Platform",
    subtitle: "National Center for Vegetation Cover (NCVC)",
    clientBadge: "NCVC Saudi Arabia",
    category: "angular",
    categories: ["enterprise", "angular", "gis"],
    role: "Senior Frontend Engineer",
    domain: "tashjeer.ncvc.gov.sa",
    desc: "National portal for tree-planting contributions, site suggestions, and geospatial community engagement driving the Saudi Green Initiative.",
    highlights: [
      "Geospatial citizen contribution tracking driving the Saudi Green Initiative",
      "Integrated interactive Esri map layers with custom GIS parcel queries",
      "Full bilingual Arabic RTL & English LTR interface with PrimeNG",
    ],
    img: "assets/tashjeer_platform.png",
    demo: "https://tashjeer.ncvc.gov.sa",
    isInternal: false,
    tags: [
      "Angular",
      "ABP Framework",
      "Esri Maps",
      "PrimeNG",
      "SCSS",
      "RTL/LTR",
    ],
  },
  {
    id: 4,
    title: "Smart Data Management Platform",
    subtitle: "General Authority for Survey and Geospatial Information",
    clientBadge: "GEOSA Authority",
    category: "angular",
    categories: ["enterprise", "angular", "gis"],
    role: "Frontend & GIS Developer",
    domain: "geosa.gov.sa (Internal Network)",
    desc: "Interactive enterprise dashboards and visualization components streamlining access, querying, and spatial analysis of national geospatial datasets.",
    highlights: [
      "High-throughput interactive dashboards for national geospatial datasets",
      "Built custom layer inspection & 3D terrain toggles using Esri JS SDK",
      "Engineered reusable data visualization component library in Angular",
    ],
    img: "assets/geosa_logo.svg",
    isLogo: true,
    logoBg: "dark",
    demo: "",
    isInternal: true,
    tags: ["Angular", "Esri JS SDK", "GIS Analytics", "TypeScript", "SCSS"],
  },
  {
    id: 5,
    title: "Marine Research & Permit Platform",
    subtitle: "Environmental Research & Permitting Portal",
    clientBadge: "Marine Authority",
    category: "angular",
    categories: ["enterprise", "angular"],
    role: "Senior Frontend Engineer",
    domain: "geosa.gov.sa (Internal Network)",
    desc: "Comprehensive government portal streamlining environmental researcher permit submissions, scientific reviewer queues, and marine conservation data access.",
    highlights: [
      "Streamlined researcher permit workflows & scientific reviewer decision queues",
      "Engineered accessible, scalable UI with Angular ABP Framework",
      "Strict WCAG 2.1 AA compliance & responsive design for public researchers",
    ],
    img: "assets/geosa_logo.svg",
    isLogo: true,
    logoBg: "dark",
    demo: "",
    isInternal: true,
    tags: [
      "Angular",
      "ABP Framework",
      "REST APIs",
      "TypeScript",
      "UI/UX Architecture",
    ],
  },
];

export const enterprisePortfolio = [
  {
    id: 1,
    title: "Petroleum Products Movement Monitoring",
    subtitle: "Ministry of Energy — Saudi Arabia",
    clientBadge: "Ministry of Energy",
    desc: "Integrated Aramco and Transport Authority telemetry data into an Angular ABP dashboard to track fuel supply chain movements across Saudi Arabia in real time.",
    img: "assets/ministry_of_energy.png",
    isLogo: true,
    demo: "",
    isInternal: true,
    tags: [
      "Angular",
      "ABP Framework",
      "Esri JS SDK",
      "Highcharts",
      "TypeScript",
    ],
  },
  {
    id: 2,
    title: "COP16 Event Management System",
    subtitle: "United Nations COP16",
    clientBadge: "UN COP16",
    desc: "Designed and built the full conference management web platform for UN COP16 with internationalized scheduling, delegate registration, and speaker hubs.",
    img: "assets/cop16_platform.png",
    demo: "https://www.unccdcop16.org",
    isInternal: false,
    tags: ["Angular", "TypeScript", "Tailwind CSS", "REST APIs"],
  },
  {
    id: 3,
    title: "Tashejeer Platform",
    subtitle: "National Center for Vegetation Cover (NCVC)",
    clientBadge: "NCVC",
    desc: "Geospatial citizen and organizational engagement platform enabling tree-planting contribution tracking, site suggestions, and environmental KPI monitoring.",
    img: "assets/tashjeer_platform.png",
    demo: "https://tashjeer.ncvc.gov.sa",
    isInternal: false,
    tags: ["Angular", "ABP Framework", "Esri Maps", "PrimeNG"],
  },
  {
    id: 4,
    title: "Smart Data Management Dashboard",
    subtitle: "General Authority for Survey (GEOSA)",
    clientBadge: "GEOSA",
    desc: "Built high-throughput interactive dashboards and data visualization tools for analyzing geospatial maps, land use, and spatial surveys.",
    img: "assets/geosa_logo.svg",
    isLogo: true,
    demo: "",
    isInternal: true,
    tags: ["Angular", "Esri JS SDK", "GIS Analytics", "TypeScript"],
  },
  {
    id: 5,
    title: "Marine Research Platform",
    subtitle: "Permit Management & Marine Studies",
    clientBadge: "Marine Authority",
    desc: "Streamlined researcher permits submission, reviewer queues, and research publication repositories with strict accessibility standards.",
    img: "assets/geosa_logo.svg",
    demo: "",
    isInternal: true,
    tags: ["Angular", "ABP Framework", "REST APIs", "UI/UX"],
  },
];

export const angularPortfolio = [
  {
    id: 1,
    title: "Petroleum Products Movement Monitoring",
    subtitle: "Ministry of Energy — Saudi Arabia",
    clientBadge: "Ministry of Energy",
    desc: "Angular ABP Framework architecture with modular lazy loading, Esri GIS map routes, and 30% optimized bundle performance.",
    img: "assets/ministry_of_energy.png",
    isLogo: true,
    demo: "",
    isInternal: true,
    tags: ["Angular", "ABP Framework", "Esri JS SDK", "TypeScript"],
  },
  {
    id: 2,
    title: "Tashejeer Greening Platform",
    subtitle: "National Center for Vegetation Cover",
    clientBadge: "NCVC",
    desc: "Comprehensive Angular application with PrimeNG components, geospatial map overlays, and bilingual RTL/LTR support.",
    img: "assets/tashjeer_platform.png",
    demo: "https://tashjeer.ncvc.gov.sa",
    isInternal: false,
    tags: ["Angular", "ABP Framework", "Esri Maps", "PrimeNG"],
  },
  {
    id: 3,
    title: "GEOSA Smart Data Management",
    subtitle: "Geospatial Information Authority",
    clientBadge: "GEOSA",
    desc: "Geospatial data layer inspection, interactive 3D terrain toggles, and high-performance charting with Angular.",
    img: "assets/geosa_logo.svg",
    isLogo: true,
    demo: "",
    isInternal: true,
    tags: ["Angular", "Esri JS SDK", "TypeScript", "SCSS"],
  },
  {
    id: 4,
    title: "Marine Research Platform",
    subtitle: "Environmental Research Portal",
    clientBadge: "Marine Authority",
    desc: "Permit workflows, research publishing, and user-friendly accessible front-end architecture using Angular ABP Framework.",
    // img: "assets/marine_research.jpg",
    img: "assets/geosa_logo.svg",
    demo: "",
    isInternal: true,
    tags: ["Angular", "ABP Framework", "REST APIs", "Clean Architecture"],
  },
  {
    id: 5,
    title: "COP16 Event Management System",
    subtitle: "United Nations COP16",
    clientBadge: "UN COP16",
    desc: "Designed and built the full conference management web platform for UN COP16 using Angular, with internationalized scheduling, delegate registration, and live event hubs.",
    img: "assets/cop16_platform.png",
    demo: "https://www.unccdcop16.org",
    isInternal: false,
    tags: ["Angular", "TypeScript", "Tailwind CSS", "REST APIs"],
  },
];

export const reactPortfolio = [
  {
    id: 2,
    title: "Rosewood Corporate Showcase",
    subtitle: "Luxury Architecture & Furnishings",
    clientBadge: "Freelance",
    desc: "Bespoke Next.js corporate portal with fluid transitions, responsive layouts, and modern visual design.",
    img: "assets/rosewood_web.png",
    demo: "https://rosewoodeg.com",
    isInternal: false,
    tags: ["Next.js", "React", "Tailwind CSS", "Responsive"],
  },
];

export const skillsCategories = [
  {
    category: "Frontend Development",
    icon: "code",
    skills: [
      "JavaScript (ES6+)",
      "TypeScript",
      "Angular",
      "React",
      "Redux / Toolkit",
      "Next.js",
      "ABP Framework",
      "HTML5 & Semantic UI",
      "CSS3 / Sass / SCSS",
      "Tailwind CSS",
      "Bootstrap",
      "Material UI",
      "PrimeNG",
    ],
  },
  {
    category: "UI/UX & Accessibility",
    icon: "design",
    skills: [
      "Responsive & Adaptive Design",
      "WCAG 2.1 Compliance",
      "ARIA Implementation",
      "Keyboard Navigation",
      "Cross-Browser Compatibility",
      "Figma Prototyping",
      "Design Systems Architecture",
    ],
  },
  {
    category: "Performance & Optimization",
    icon: "speed",
    skills: [
      "Lazy Loading & Code Splitting",
      "Lighthouse 95+ Audits",
      "Core Web Vitals Optimization",
      "Bundle Size Optimization",
      "Caching & State Memoization",
      "30% Load Time Reduction",
    ],
  },
  {
    category: "Core Strengths & Architecture",
    icon: "geo",
    skills: [
      "Scalable Component Architecture",
      "State Management (Redux / Services)",
      "Complex Dashboards & Data Viz",
      "Esri JavaScript SDK (Maps Integration)",
      "Agile / Scrum Methodologies",
      "Code Review & Mentorship",
    ],
  },
  {
    category: "Backend & APIs",
    icon: "server",
    skills: [
      "Node.js",
      "Express.js",
      "RESTful APIs Integration",
      "Strapi CMS",
      "Ruby on Rails",
      "SQL Server",
      "MongoDB",
    ],
  },
  {
    category: "Tools & Platforms",
    icon: "tools",
    skills: [
      "Git & GitHub",
      "GitLab",
      "Docker",
      "Azure DevOps",
      "Jira & Agile Boards",
      "Vercel / Netlify",
      "Jest & Automated Testing",
    ],
  },
];

export const certificationsData = [
  {
    id: 1,
    title: "Full Stack Web Development",
    issuer: "Microverse",
    date: "July 2022",
    hours: "1300+ Hours Intensive",
    desc: "Mastered full-stack development, remote pair programming, clean code architecture, and Git flow in an international distributed environment.",
    badge: "Full Stack",
    link: "",
  },
  {
    id: 2,
    title: "Product Development Certificate",
    issuer: "Co.Lab",
    date: "May 2022",
    hours: "Agile Production MVP",
    desc: "Collaborated in a cross-functional team with designers and PMs to architect, build, test, and ship a production-grade MVP product.",
    badge: "Product Dev",
    link: "https://www.joincolab.io/certificate/omar-salem",
  },
  {
    id: 3,
    title: "React & Redux Specialization",
    issuer: "Microverse",
    date: "March 2022",
    hours: "Advanced Frontend",
    desc: "Deep-dive specialization in component lifecycle, Redux state management, asynchronous thunks, and performance profiling.",
    badge: "React / Redux",
    link: "",
  },
];
